import { httpGet, httpPost, httpPostRaw } from './api/axios_api';
import Constants from '../constants/constants';
import actions from './user_actions';
import { login as loginAction, userFromToken, logout as clearUser } from './user';

export async function editHomePlayer(playerID, firstName, lastName, login, password) {
  const url = `${Constants.BACKEND_URL}/edit-home-player/`;
  const config = {
    params: {
      player_id: playerID,
      first_name: firstName,
      last_name: lastName,
      login: login,
      password: password,
    },
  };
  return httpPost(url, config);
}

export async function loginExists(login, userId) {
  const url = `${Constants.BACKEND_URL}/user/login-exists/`;
  const config = {
    params: {
      login: login,
      userId: userId,
    },
  };
  return httpGet(url, config);
}

export async function activateHomePlayer(playerID, firstName, lastName, login, password) {
  const url = `${Constants.BACKEND_URL}/activate-home-player/`;
  const config = {
    params: {
      player_id: playerID,
      first_name: firstName,
      last_name: lastName,
      login: login,
      password: password,
    },
  };
  return httpPost(url, config);
}

export async function addOrganization(organizationData) {
  const url = `${Constants.BACKEND_URL}/add-organization`;
  const config = {
    params: {
      organization_name: organizationData.name,
    },
  };
  return httpPost(url, config);
}

export async function getPersonnel(organizationID) {
  const url = `${Constants.BACKEND_URL}/get-personnel/${organizationID}`;
  return httpGet(url, {});
}

export async function getPeers(personnelID) {
  const url = `${Constants.BACKEND_URL}/get-peers/${personnelID}`;
  return httpGet(url, {});
}

export async function archivePersonnel(personnelID, newOwnerID) {
  const url = `${Constants.BACKEND_URL}/archive-personnel`;
  const config = {
    params: {
      personnel_id: personnelID,
      new_owner_id: newOwnerID,
    },
  };
  return httpPost(url, config);
}

export async function setPersonnelLockoutStatus(personnelID, newStatus) {
  const url = `${Constants.BACKEND_URL}/set-personnel-lockout-status/`;
  const config = {
    params: {
      personnel_id: personnelID,
      lockout_status: newStatus,
    },
  };
  return httpPost(url, config);
}

export async function editPersonnel(personnelID, editData) {
  const url = `${Constants.BACKEND_URL}/edit-personnel/`;
  const config = {
    params: {
      personnel_id: personnelID,
      edit_data: editData,
    },
  };
  return httpPost(url, config);
}

export async function addPersonnel(new_personnel_data) {
  const url = `${Constants.BACKEND_URL}/add-personnel/`;
  const config = {
    params: {
      new_personnel_data: new_personnel_data,
    },
  };
  return httpPost(url, config);
}

export async function getAllPersonnel() {
  const url = `${Constants.BACKEND_URL}/get-all-personnel/`;
  return httpGet(url, {});
}

export async function getPersonnelRevised({ query = '', page = 1, organizationIds = [] }) {
  let urlString = `${Constants.BACKEND_URL}/get-all-personnel-revised`;
  if (urlString.startsWith('//')) {
    urlString = `https:${urlString}`;
  }

  const url = new URL(urlString);

  // Add query parameters
  if (query) url.searchParams.append('query', query);
  url.searchParams.append('page', page);
  if (organizationIds.length > 0) {
    url.searchParams.append('organization_ids', organizationIds.join(','));
  }

  return httpGet(url.toString(), {});
}
export async function getCircleMembers(playerID) {
  const url = `${Constants.BACKEND_URL}/get-circle-members/${playerID}`;
  return httpGet(url, {});
}

export async function editCircleMember(
  playerID,
  firstName,
  lastName,
  email,
  relationshipToUser,
  phoneNumber,
  circleMemberID
) {
  const url = `${Constants.BACKEND_URL}/edit-circle-member/`;
  const config = {
    params: {
      player_id: playerID,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone_number: phoneNumber,
      relationship_to_user: relationshipToUser,
      circle_member_id: circleMemberID,
    },
  };
  return httpPost(url, config);
}

export async function addCircleMember(playerID, firstName, lastName, email, relationshipToUser, phoneNumber) {
  const url = `${Constants.BACKEND_URL}/add-circle-member/`;
  const config = {
    params: {
      player_id: playerID,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone_number: phoneNumber,
      relationship_to_user: relationshipToUser,
    },
  };
  return httpPost(url, config);
}

export async function getUserOrganizations() {
  const url = `${Constants.BACKEND_URL}/get-user-organizations`;
  return httpGet(url, {});
}

export async function getTeamMembers(showAll) {
  if (typeof showAll === 'undefined') {
    showAll = false;
  }
  const url = `${Constants.BACKEND_URL}/get-team-members/${showAll}`;
  return httpGet(url, {});
}

export async function getRoles() {
  const url = `${Constants.BACKEND_URL}/get-roles/`;
  return httpGet(url, {});
}

export function keepAlive() {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/keep-alive`;
    httpPost(url, {}).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.keepAlive,
        });
      } else {
        //TODO: handle results load error
      }
    });
  };
}

const loginUser = async (username, password) => {
  const url = `${Constants.BACKEND_URL}/login`;
  const config = { params: { email: username, password } };
  return await httpPostRaw(url, config);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const login = (username, password) => async (dispatch) => {
  try {
    const userObject = await loginUser(username, password);
    dispatch(loginAction(userObject));
  } catch (error) {
    dispatch(loginAction(error));
  }
};

const logoutUser = async () => {
  const url = `${Constants.BACKEND_URL}/logout`;
  const config = {};
  return await httpPostRaw(url, config);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logout = () => async (dispatch) => {
  try {
    const result = await logoutUser();
    if (result?.success) {
      dispatch(clearUser());
    } else {
      console.error('Failed to log out');
    }
  } catch (error) {
    console.error(error);
  }
};

const _getUserFromToken = async () => {
  const url = `${import.meta.env.VITE_API_SERVER}/userFromToken`;
  return await httpPostRaw(url, {});
};

export const getUserFromToken = () => async (dispatch) => {
  const result = await _getUserFromToken();

  dispatch(userFromToken(result));
};
